export const messages = {
  "en-US": {
      "firstName" : "First name",
      "middleNames" : "Middle name",
      "surname": "Surname",
      "streetType": "Street type",
      "address" : "Address",
      "addressLine1": "Line 1",
      "addressLine2": "Line 2",
      "suburb": "Suburb",
      "state": "State",
      "postcode": "Postcode",
      "dob": "Date of birth (DD/MM/YYYY)",
      "email": "Email",
      "phoneNumber": "Mobile phone number",
      "pinCode": "Pin code",
      "propertyBeingTransacted": "Address of property being transacted",

      "selectStreetType": "Select your street type...",
      "AVE": "Avenue",
      "CIR": "Circle",
      "CCT": "Circuit",
      "CL": "Close",
      "CT": "Court",
      "CRES": "Crescent",
      "DR": "Drive",
      "ESP": "Esplanade",
      "EXP": "Expressway",
      "HWY": "Highway",
      "LANE": "Lane",
      "MWY": "Motorway",
      "PDE": "Parade",
      "PL": "Place",
      "RD": "Road",
      "SQ": "Square",
      "ST": "Street",
      "TCE": "Terrace",
      "WAY": "Way",

      "selectState": "Select your State/Territory...",
      "NSW": "NSW",
      "VIC": "VIC",
      "QLD": "QLD",
      "SA": "SA",
      "WA": "WA",
      "ACT": "ACT",
      "NT": "NT",
      "TAS": "TAS",

      "submitDetails": "Submit details"
  }
}
